import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import GAlign from "./GAlign";
import { data } from "../Data/data";
import Animation from "../animations/Animation";
import useMediaQuery from "../hooks/useMediaQuery";

const RewardsComp = () => {
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");
   return (
      <Container>
         <Row className="align-items-center">
            <Col lg={3} md={3} sm={12} xs={12}>
               <Animation fade bottom>
                  <h5 className="fBold mobTextCenter mobMb50">
                     Rewards and
                     <br /> Recognition
                  </h5>
               </Animation>
            </Col>
            <Col lg={9} md={9} sm={12} xs={12}>
               <Animation fade bottom>
                  <div className="row">
                     {data.rewardsAndRecognition.map((reward) => (
                        <div className={`col-6 col-md-3 d-flex ${lgBreakpoint ? "justify-content-end" : "justify-content-center"}`}>
                           <img src={reward.rewardImg} alt={reward.rewardName} key={reward.id} />
                        </div>
                     ))}
                  </div>
               </Animation>
            </Col>
         </Row>
      </Container>
   );
};

export default RewardsComp;
